import instance from '../config/axios';

export async function downloadOrderHistoryReport(
  accessToken: string,
  reportId: string,
) {
  try {
    const response = await instance({
      method: 'GET',
      url: `/api/v1/order/report/download/${reportId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      responseType: 'blob',
    });

    return response.data;
  } catch (e) {
    console.log(e);
    return false;
  }
}
